/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { ITreatmentPlan } from 'app/shared/model/treatment-plan.model';
import { IDoctor } from 'app/shared/model/doctor.model';

export interface ITreatmentNotes {
  id?: string;
  progressSummary?: string | null;
  proposedPlan?: string | null;
  otherNotes?: string | null;
  active?: boolean;
  timestampentry?: number;
  microSec?: number;
  lastupdated?: number;
  cursor?: number;
  treatmentPlan?: ITreatmentPlan;
  doctor?: IDoctor;
}

export const defaultValue: Readonly<ITreatmentNotes> = {
  active: false,
};
